import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const bingMapSlice = createSlice({
  name: "bingMap",
  initialState: { currentBingMap: null },
  reducers: {
    setBingMap: (
      state: { currentBingMap: any | null },
      action: PayloadAction<any | null>,
    ) => {
      state.currentBingMap = action.payload;
    },
  },
});

export const { setBingMap } = bingMapSlice.actions;

export default bingMapSlice.reducer;
